const tableHeaders = [
  {
    label: 'date',
    key: 'createdAt',
    filter: 'date',
    defaultSort: true,
    sortReverse: 'desc',
  },
  {
    label: 'form-type',
    key: 'formType',
    defaultSort: true,
  },
  {
    label: 'form-layout',
    key: 'layout',
    defaultSort: true,
  },
  {
    label: 'Form Name',
    key: 'formName',
    defaultSort: true,
  },
  {
    label: 'time-period',
    key: 'period',
    defaultSort: true,
  },
  {
    label: 'status',
    key: 'currentOverAllStatus',
    defaultSort: true,
  },
  {
    label: 'view',
    key: 'action',
    defaultSort: true,
  },
];

export default () => tableHeaders;
